import React from 'react';
import './Loading.css';

// 统一的加载动画组件
const Loading = ({ fullScreen = true }) => {
  return (
    <div className={`elegant-loading ${fullScreen ? 'fullscreen' : ''}`}>
      <div className="elegant-loading-spinner"></div>
    </div>
  );
};

export default Loading; 